import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{attrs:{"flat":"","outlined":"","dense":""}},[(_vm.name)?_c(VCardTitle,[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c(VCardText,[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h3',[_vm._v(_vm._s(_vm.count))]),_c('div',[_c(VBtn,{attrs:{"color":"red","text":""}},[_vm._v(_vm._s(_vm.subjectCount + ' ' + _vm.type))])],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }